var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    enableBackground: "new 0 0 538.8 131",
    xmlSpace: "preserve",
    viewBox: "-0.5 34.88 539.8 83.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3C3F45",
    strokeMiterlimit: 10,
    d: "M0,59.5c0,0,34.9-1.5,72.6,38.5c0,0,23.3,30.1,33.4-5.4  c0,0,16.7-94.4,39.9-40.7l20.3,54.7c0,0,9.4,25.4,18.2,0c0,0,4.4-21.8,12.3-21.1c0,0,16-0.7,16-34.1c0,0,11.6-24,21.1,7.3  c0,0,5.1,47.2,29,42.1c0,0,55.2-30.5,66.1-4.4c0,0,21.8,40.7,37,9.4l17.4-34.9c0,0,12.3-29,32.7,5.1c0,0,13.8,33.4,34.1,20.3  c0,0,37-35.6,64.6-14.5l24,18.2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3C3F45",
    strokeMiterlimit: 10,
    d: "M538.8,59.5c0,0-0.9,0-2.5,0.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3C3F45",
    strokeMiterlimit: 10,
    strokeDasharray: "5.0166,5.0166",
    d: "M531.3,60.1   c-12.2,1.8-37.9,9.1-65.1,37.9c0,0-23.3,30.1-33.4-5.4c0,0-16.7-94.4-39.9-40.7l-20.3,54.7c0,0-9.4,25.4-18.2,0   c0,0-4.4-21.8-12.3-21.1c0,0-16-0.7-16-34.1c0,0-11.6-24-21.1,7.3c0,0-5.1,47.2-29,42.1c0,0-55.2-30.5-66.1-4.4   c0,0-21.8,40.7-37,9.4l-17.4-34.9c0,0-12.3-29-32.7,5.1c0,0-13.8,33.4-34.1,20.3c0,0-37-35.6-64.6-14.5L4,97.1"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#3C3F45",
    strokeMiterlimit: 10,
    x1: 2,
    y1: 98.7,
    x2: 0,
    y2: 100.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines);
export default __webpack_public_path__ + "static/media/Lines.10c42e61a071bb82f5d72c701bf454cf.svg";
export { ForwardRef as ReactComponent };